export default "__VITE_ASSET__CL1I8tQ6__"